import { SubscriptionSection } from '../billing/SubscriptionSection';

const PlanSection = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-ui-text-primary mb-2">Kolega.dev</h2>
        <p className="text-ui-text-secondary">Automated AI security scans platform. Connect your GitHub repos, trigger comprehensive security scans, and get AI-powered pull request fixes.</p>
      </div>

      {/* Subscription Section */}
      <SubscriptionSection />

      {/* Divider */}
      <div className="hidden border-t border-ui-border-primary my-8"></div>

      {/* Upgrades Section */}
      <div className="hidden bg-ui-background-tertiary dark:bg-ui-background-tertiary rounded-lg border border-ui-border-primary p-6">
        <h3 className="font-medium text-ui-text-primary mb-4">Upgrades</h3>
        <p className="text-sm text-ui-text-secondary mb-4">Individual bolt-on upgrades available for Creator and Pro packages.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="p-4 bg-ui-background-secondary rounded-lg border border-ui-border-primary">
            <h4 className="font-medium text-ui-text-primary mb-2">Creator Auto Build Templates</h4>
            <ul className="text-sm text-ui-text-secondary space-y-1">
              <li>• Mobile App (iOS & Android)</li>
              <li>• Business API Service</li>
              <li>• Business Automation Tool</li>
              <li>• Interactive Web Application</li>
              <li>• Business Service Backend</li>
            </ul>
          </div>
          
          <div className="p-4 bg-ui-background-secondary rounded-lg border border-ui-border-primary">
            <h4 className="font-medium text-ui-text-primary mb-2">Pro & Creator Storage</h4>
            <ul className="text-sm text-ui-text-secondary space-y-1">
              <li>• Bundles of 5GB Extra Storage</li>
              <li>• Additional App Hosting (per app)</li>
            </ul>
          </div>
          
          <div className="p-4 bg-ui-background-secondary rounded-lg border border-ui-border-primary">
            <h4 className="font-medium text-ui-text-primary mb-2">Pro Compliance</h4>
            <ul className="text-sm text-ui-text-secondary space-y-1">
              <li>• Compliance Engine Upgrade</li>
              <li>• Contact our sales team for pricing</li>
              <li>• Flexible implementation options</li>
              <li>• Custom integration support</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-6 text-center">
          <button 
            onClick={() => window.open('https://kolega.dev/contact.html', '_blank')}
            className="px-6 py-3 bg-brand-primary text-black font-medium rounded-lg hover:bg-brand-primaryDark transition-colors"
            data-tour="contact-sales-button"
          >
            Contact Sales
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanSection; 